import { getLightenColor, getDarkenColor, hexToRgbA } from "./";

export default (type, colors) => {
  const styles = {
    default: {
      'c-checkbox-toggle__indicator': {
        background: getLightenColor(colors.primary, 2),
        customCSS: `
          .c-checkbox-toggle__indicator:after {
            box-shadow: 1px 1px 0 0 ${hexToRgbA(getLightenColor(colors.secondary, 0.21), 0.5)};
          }
          .c-checkbox-toggle__input:focus + .c-checkbox-toggle__bits .c-checkbox-toggle__indicator [data-whatinput=keyboard] {
            outline: ${colors.quaternary} auto 1px;
          }
        `
      },
      'c-checkbox-toggle__input': {
        customCSS: `
          .c-checkbox-toggle__input:checked + .c-checkbox-toggle__bits .c-checkbox-toggle__positions:before {
            background: ${colors.checkbox_content};
            box-shadow: 0 0 4px 0 ${getLightenColor(colors.checkbox_content, 0.65)};
          }
          
        `
      },
      'c-checkbox-toggle__label': {
        customCSS: `
          .c-checkbox-toggle__label small {
            color: ${colors.offgray_dark};
          }
        `
      },
      'c-checkbox-toggle__positions': {
        customCSS: `
          .c-checkbox-toggle__positions:before, 
          .c-checkbox-toggle__positions:after {
            box-shadow: 1px 1px 0 0 ${hexToRgbA(getLightenColor(colors.secondary, 0.21), 0.5)};
            background: ${getLightenColor(colors.secondary, 0.21)};
          }
          .accorditabs-item-body-wrapper .c-checkbox-toggle__input:checked + .c-checkbox-toggle__bits .c-checkbox-toggle__positions:before {
            background: ${getLightenColor(colors.secondary, 0.27)};
            box-shadow: 0 0 4px 0 ${getLightenColor(getLightenColor(colors.secondary, 0.27), 0.2)};
          }
        `
      }
    },
    type1: {
      'c-checkbox-toggle': {
        display: 'flex',
        minHeight: '33px',  
        paddingRight: '40px',
        alignItems: 'center',
        customCSS: `
        .c-checkbox-toggle:after {
          background: ${getDarkenColor(colors.light, 0.026)}
        }
        `
      },
      'c-checkbox-toggle__label': {
        color: colors.dark,
        fontSize: '14px',
        customCSS: `
          .c-checkbox-toggle__label .icon {
            margin-right: 30px;
            text-align: left;
            width: 18px;
            color: ${colors.primary}!important;
          }
          .c-results-filters__filter--all .c-checkbox-toggle__label {
            color: #c4c4c4!important;
          }
          .c-checkbox-toggle__label small {
            color: ${colors.offgray_dark};
          }
        `
      },
      'c-checkbox-toggle__indicator': {
        width: '28px',
        height: '16px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: '#c4c4c4',
        customCSS: `
          .c-checkbox-toggle__indicator:after {
            width: 10px;
            height: 10px;
            top: 3px;
            left: 3px;
          }
          .c-checkbox-toggle__indicator.checked:after {
            left: 14px!important;
          }
          .c-checkbox-toggle__indicator.checked {
            background: ${colors.primary}!important;
          }
          .state-filter-active .c-checkbox-toggle__input:not(:checked) + .c-checkbox-toggle__bits .c-checkbox-toggle__label {
            opacity: 1!important;
          }
        `
      },
      'c-results-filters__filter__label' : {
        width: '100px'
      },
      'c-checkbox-toggle__positions': {
        customCSS: `
          .c-checkbox-toggle__positions:after, 
          .c-checkbox-toggle__positions:before {
            display: none;
          }
        `
      },
      'c-checkbox-toggle__input': {
        customCSS: `
          .c-checkbox-toggle__input:checked + .c-checkbox-toggle__bits .c-checkbox-toggle__positions:before {
            background: ${colors.checkbox_content};
            box-shadow: 0 0 4px 0 ${getLightenColor(colors.checkbox_content, 0.65)};
          }
          .c-checkbox-toggle__input:not(:checked) + .c-checkbox-toggle__bits .icon {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cCheckbox.js